import { Environment } from "../../../environment";
import { Api } from "../axios-config";

export interface IBanner {
    id: string;
    image: string; // Base64 string
    title: string;
    link: string;
    active: boolean;
    order: number;
    createdAt: string;
    imageUrl: string; // Optional: URL if backend returns it, otherwise use 'image'
}

export interface IBannerDetail {
    id: string;
    image: string; // Base64 string
    title: string;
    link: string;
    active: boolean;
    order: number;
    createdAt: string;
    imageUrl: string;
}

export type TBannerWithTotalCount = {
    data: IBanner[];
    totalCount: number;
}

export interface IBannerCreate {
    title: string;
    link?: string;
    active: boolean;
    image: string; // Base64
}

export interface IBannerUpdate {
    title?: string;
    link?: string;
    active?: boolean;
    image?: string; // Base64
    order?: number;
}

const getAll = async (page = 1, filter = ""): Promise<TBannerWithTotalCount | Error> => {
    try {
        const urlRelativa = `/banners?_page=${page}&_limit=${Environment.LIMITE_LINHAS}&title_like=${filter}&_sort=order&_order=asc`;
        const { data, headers } = await Api().get(urlRelativa);

        if (data) {
            return {
                data,
                totalCount: Number(headers['x-total-count'] || Environment.LIMITE_LINHAS),
            };
        }

        return new Error('Não foi possível carregar a lista de banners.');
    } catch (error) {
        console.error(error);
        // Force friendly message
        return new Error('Não foi possível carregar a lista de banners.');
    }
};

const getById = async (id: string): Promise<IBannerDetail | Error> => {
    try {
        const { data } = await Api().get(`/banners/${id}`);
        if (data) {
            return data;
        }

        return new Error('Não foi possível carregar os detalhes do banner.');
    } catch (error) {
        console.error(error);
        return new Error('Não foi possível carregar os detalhes do banner.');
    }
};

const create = async (dados: IBannerCreate): Promise<string | Error> => {
    try {
        const { data } = await Api().post<IBanner>('/banners', dados);
        if (data) {
            return data.id;
        }

        return new Error('Erro ao cadastrar o novo banner.');
    } catch (error) {
        console.error(error);
        return new Error('Erro ao cadastrar o novo banner.');
    }
};

const updateById = async (id: string, dados: IBannerUpdate): Promise<void | Error> => {
    try {
        await Api().put(`/banners/${id}`, dados);
    } catch (error) {
        console.error(error);
        return new Error('Erro ao atualizar o banner.');
    }
};

const deleteById = async (id: string): Promise<void | Error> => {
    try {
        await Api().delete(`/banners/${id}`);
    } catch (error) {
        console.error(error);
        return new Error('Erro ao excluir o banner.');
    }
};

const updateOrder = async (id: string, newOrder: number): Promise<void | Error> => {
    try {
        await Api().patch(`/banners/${id}`, { order: newOrder });
    } catch (error) {
        console.error(error);
        return new Error('Erro ao reordenar os banners.');
    }
};

export const BannerService = {
    getAll,
    getById,
    create,
    updateById,
    deleteById,
    updateOrder,
};
